import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  radioIcon: (props) => ({
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    border: '1px solid #e6e6e6',
    display: 'inline-flex',
    verticalAlign: 'middle',
    lineHeight: '18px',
    position: 'relative',
    transition: 'border-color .6s ease, transform .6s cubic-bezier(.175, .885, .32, 2)',
    margin: '0 8px',

    '&:before, &:after': {
      content: '""',
      width: '16px',
      height: '16px',
      display: 'block',
      borderRadius: '50%',
      left: '0px',
      top: '0px',
      position: 'absolute',
      background: '#fff',
      transition: 'background .2s ease, transform .5s cubic-bezier(.175, .885, .32, 2)',
    },

    '&:after': {
      transform: 'scale(.78)',
      transition: 'transform .6s cubic-bezier(.175, .885, .32, 1.4)',
    },

    '&.checked': {
      borderColor: theme.colors[props._color].normal,
      '&:before': {
        transform: 'scale(1)',
        background: theme.colors[props._color].normal,
      },
      '&:after': {
        transform: 'scale(.38)',
        transition: 'transform .3s ease',
      },
    },
  }),
}));

export default useStyle;
